export default {
    props: {
        messagesClose: {
            type: String,
            default: undefined,
            kComposite: 'messages.close'
        }, 
        messagesPromptInput: {
            type: String,
            default: undefined,
            kComposite: 'messages.promptInput'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/KendoDialog/Messages.js